<!-- 员工列表 -->
<template>
  <div class="definiteDetail" v-loading="loading">
    <div class="s_wrapper">
      <el-input class="s_input" v-model="employeeName" placeholder="搜索姓名" suffix-icon="el-icon-search" @change="onSearch" clearable></el-input>
    </div>
    <!-- 表格 -->
    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540">
        <el-table-column label="序号" width="80" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column prop="picUrl" label="查看头像" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-image v-show="false" :preview-src-list="srcList" ref="previewImg"></el-image>
            <div style="color: #069BBC;cursor: pointer;" @click="handleCommandLogo(scope.row.picUrl)">查看头像</div>
          </template>
        </el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip prop="employeeCode" label="员工编号"></el-table-column>
        <el-table-column min-width="150" show-overflow-tooltip prop="employeeName" label="姓名"></el-table-column>
        <el-table-column min-width="100" show-overflow-tooltip prop="sex" label="性别">
          <template slot-scope="scope">
            {{scope.row.sex==1?'男':'女'}}
          </template>
        </el-table-column>
        <el-table-column min-width="150" show-overflow-tooltip prop="idNum" label="身份证号"></el-table-column>
        <el-table-column min-width="130" show-overflow-tooltip prop="birthDate" label="出生日期"></el-table-column>
        <el-table-column min-width="100" show-overflow-tooltip prop="departmentName" label="部门"></el-table-column>
        <el-table-column min-width="130" show-overflow-tooltip prop="positionName" label="岗位"></el-table-column>
        <el-table-column min-width="130" show-overflow-tooltip prop="contactTel" label="联系电话"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount">
    </el-pagination>

  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      employeeName: '', // 姓名

      // 表格数据
      tableData: [],
      // 分页
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
      srcList: []
    }
  },
  created() {
    this.getNameList();
  },
  methods: {

    // 查看图片
    handleCommandLogo(imageUrl) {
      // console.log('查看图片', imageUrl);

      if (imageUrl) {
        this.srcList = [imageUrl];
        this.$refs.previewImg.showViewer = true;
      } else {
        this.$message.error("未上传员工头像!");
      }
    },    // 获取列表
    getNameList() {
      this.loading = true;
      let params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        employeeName: this.employeeName,
        storeId: this.$store.state.userInfo.bizId,
      };
      this.$axios.get(this.$api.employeeInfoSelect, {
        params
      }).then((res) => {
        if (res.code == 100) {
          this.tableData = res.result.list;
          this.totalItemsCount = res.result.totalCount;

        }
        this.loading = false;
      }).catch(err => {
        this.loading = false
        this.$message.error(err.desc)
      })
    },
    // 清空
    clearData() {
      this.tableData = [];
      this.currentPage = 1;
    },
    // 搜索
    onSearch() {
      this.clearData();
      this.getNameList();
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.clearData();
      this.pageSize = e;
      this.getNameList();
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = [];
      this.currentPage = e;
      this.getNameList();
    },
  }

}
</script>

<style lang="scss" scoped>
.definiteDetail {
}
</style>
